"use client";
import { jsx } from "react/jsx-runtime";
import React from "react";
import { StyledIconButton, ButtonContainer } from "./styles.js";
import { ICON_SIZE, COMPONENT_NAME } from "./types.js";
import { getDataTestId } from "../../Util/index.js";
const IconButtonV2 = ({
  children,
  type = "standard",
  size = "medium",
  title,
  onClick,
  "aria-label": ariaLabel,
  uniqueId,
  ...rest
}) => {
  if (!children) {
    return null;
  }
  const updatedChildren = React.cloneElement(children, {
    sx: {
      ...children.props.sx,
      width: ICON_SIZE[size],
      height: ICON_SIZE[size]
    }
  });
  return /* @__PURE__ */ jsx(
    StyledIconButton,
    {
      onClick,
      size,
      title,
      "data-testid": getDataTestId(COMPONENT_NAME, uniqueId),
      "aria-label": ariaLabel,
      ...rest,
      children: /* @__PURE__ */ jsx(ButtonContainer, { size, type, children: updatedChildren })
    }
  );
};
IconButtonV2.displayName = COMPONENT_NAME;
export {
  IconButtonV2
};
